module.exports = __webpack_public_path__ + "h5/img/wancheng.871d6374.png";